/* eslint-disable spire/export-styles */
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { getPrevCurrentNextQueryString } from "@insite/mobius/utilities/linkElementsManipulation";

const mapStateToProps = (state: ApplicationState) => {
    const {
        pages: {
            productList: { parameter },
        },
    } = state;
    const productsDataView = getProductsDataView(state, parameter);
    return {
    currentPage: getCurrentPage(state),
    productsDataView
}};

type Props = WidgetProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;

const CategoryName = ({ category, currentPage, productsDataView }: Props) => {
    if (!category) {
        return null;
    }

    const productsData = JSON.parse(JSON.stringify(productsDataView));
    const { currentQueryString } = getPrevCurrentNextQueryString(
        productsData?.pagination?.prevPageUri,
        productsData?.pagination?.nextPageUri,
        productsData?.pagination?.currentpage,
        "",
    );
    
    const params = new URLSearchParams(currentQueryString);
    const page = params.get("page"); 
    const pageNumber = page ? parseInt(page, 10) : 1; // Default to 1 if not present

    const isSearchCrawler = getIsWebCrawler();

    return (
        <Typography
            variant={isSearchCrawler && currentPage.type === "CategoryDetailsPage" ? "h1" : "h1"}
            data-test-selector={`categoryName_${category.shortDescription ?? category.name}`}
        >
            {category.shortDescription ?? category.name} {pageNumber > 1 ? `- Page ${pageNumber}`: null}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(CategoryName)),
    definition: {
        group: "Category Details",
        icon: "folder-bookmark",
        allowedContexts: ["CategoryDetailsPage", "ProductDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
